var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "well well-no-shadow p-0 col span_12 mb-5 ml-0" },
    [
      _c("div", { staticClass: "flex-level p-3" }, [
        _c("p", { staticClass: "bold mb-0 mt-0" }, [
          _vm._v(_vm._s(_vm.titleAccount))
        ])
      ]),
      _vm._v(" "),
      !_vm.isSetup
        ? _c("div", [
            _c("div", { staticClass: "flex-level p-3 bt-1" }, [
              _c("div", { staticClass: "wp-7" }, [
                _c("p", { staticClass: "bold mb-1 mt-0" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Configuration")))
                ]),
                _vm._v(" "),
                _vm.isAdmin & !_vm.isEmailsSentFromCorp
                  ? _c("p", { staticClass: "my-0" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Nous vous invitons à configurer le service email et choisir un mode (synchronisation ou transfert) afin de pouvoir envoyer vos emails depuis Sellsy."
                            )
                          ) +
                          "\n                "
                      )
                    ])
                  : _c("p", { staticClass: "my-0" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Nous vous invitons à configurer le service email et choisir un mode (synchronisation ou transfert) afin de pouvoir envoyer vos emails depuis Sellsy."
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-0 mt-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "link mb-0 mt-0 fs-3",
                      attrs: {
                        href: "https://help.sellsy.com/",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$l10n.__("En savoir plus")))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-item-right" },
                [
                  _vm.isAdmin || !_vm.isEmailsSentFromCorp
                    ? _c(
                        "router-link",
                        { attrs: { to: { name: "onboarding.email" } } },
                        [
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__("email.configure_email_service")
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _c(
            "div",
            [
              _vm.isSyncMode
                ? _c(
                    "EmailSettingsAccountModeSync",
                    _vm._b(
                      {
                        attrs: {
                          isEmailsSentFromCorp: _vm.isEmailsSentFromCorp
                        }
                      },
                      "EmailSettingsAccountModeSync",
                      _vm.account,
                      false
                    )
                  )
                : _c(
                    "EmailSettingsAccountModeTransfer",
                    _vm._b(
                      {
                        attrs: {
                          isEmailsSentFromCorp: _vm.isEmailsSentFromCorp,
                          selectedProvider: _vm.provider
                        }
                      },
                      "EmailSettingsAccountModeTransfer",
                      _vm.account,
                      false
                    )
                  )
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }